import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Button, 
  Stack, 
  Alert,
  Snackbar,
  Box
} from '@mui/material';
import { Clock } from 'lucide-react';
import { styled } from '@mui/material/styles';
import SphereAnimation from './Sphere' // Assuming this component exists

const StyledSection = styled('section')({
  paddingTop: '8rem',
  paddingBottom: '4rem',
});

const ContentWrapper = styled('div')({
  maxWidth: '800px',
  margin: '0 auto',
});

const Hero = () => {
  // State for the warning toast
  const [open, setOpen] = useState(true);

  // Reopen the toast after 1 minute if closed
  useEffect(() => {
    if (!open) {
      const timer = setTimeout(() => {
        setOpen(true);
      }, 60000);
      return () => clearTimeout(timer);
    }
  }, [open]);

  return (
    <StyledSection>
      
      <Container>
        <ContentWrapper>
          <Stack spacing={4} alignItems="center">
            <Typography 
              variant="h1" 
              align="center"
              sx={{
                color: '#0d9488',
                fontWeight: 700,
                fontSize: { xs: '2.5rem', md: '3rem' },
                mb: 2
              }}
            >
              Modernize your digital presence with effortlessly awesome search and chat
            </Typography>
            
            <Typography 
              variant="h5" 
              align="center"
              color="text.secondary"
              sx={{ mb: 4 }}
            >
              Modernize your content in just
              <span style={{ fontWeight: 900 }}> 10 minutes </span>
              starting from
              <span style={{ fontWeight: 900 }}> $9/month</span>
            </Typography>

            <SphereAnimation />
            
            <Stack 
              direction="row" 
              spacing={2} 
              justifyContent="center"
            >
              <Button
                variant="contained"
                size="large"
                startIcon={<Clock size={20} />}
                sx={{
                  backgroundColor: '#0d9488',
                  '&:hover': {
                    backgroundColor: 'rgba(13, 148, 136, 0.8)',
                  },
                }}
              >
                Get Started Now
              </Button>
              
              <Button
                variant="outlined"
                size="large"
                sx={{
                  borderColor: '#0d9488',
                  color: '#0d9488',
                  '&:hover': {
                    borderColor: 'rgba(13, 148, 136, 0.8)',
                    backgroundColor: 'rgba(13, 148, 136, 0.04)',
                  },
                }}
              >
                View Demo
              </Button>
            </Stack>
          </Stack>
        </ContentWrapper>
      </Container>
    </StyledSection>
  );
};

export default Hero;